export default __webpack_public_path__ + "static/media/legal-team-prosecutor.4f576271.png";